/* eslint-disable */
import axios from 'axios'
import CryptoJS from 'crypto-js'
export default {
    // AES加密
    encryptMessage(message) {//message-要加密的数据
        function _0x32f5() { var _0x533a1b = ['\x34\x30\x36\x38\x35\x33\x35\x43\x76\x41\x6c\x5a\x46', '\x38\x62\x76\x71\x7a\x56\x4a', '\x65\x6e\x63\x72\x79\x70\x74', '\x35\x35\x32\x34\x35\x36\x30\x6e\x4f\x47\x49\x59\x64', '\x65\x6e\x63', '\x31\x34\x33\x38\x30\x36\x4b\x54\x4c\x73\x76\x68', '\x55\x74\x66\x38', '\x41\x45\x53', '\x33\x68\x69\x51\x50\x6a\x53', '\x36\x66\x64\x47\x5a\x59\x4a', '\x33\x34\x36\x34\x34\x33\x4f\x63\x68\x41\x5a\x48', '\x74\x6f\x53\x74\x72\x69\x6e\x67', '\x34\x34\x30\x33\x32\x32\x30\x62\x4b\x76\x54\x49\x70', '\x6d\x6f\x64\x65', '\x33\x31\x34\x38\x31\x32\x38\x62\x4a\x47\x46\x5a\x6e', '\x38\x32\x32\x35\x31\x33\x33\x78\x4a\x79\x5a\x7a\x4b']; _0x32f5 = function () { return _0x533a1b; }; return _0x32f5(); } var _0x1057b5 = _0x5e74; (function (_0x11ea85, _0x421221) { var _0x481252 = _0x5e74, _0x35ef25 = _0x11ea85(); while (!![]) { try { var _0x5c6dc1 = -parseInt(_0x481252(0x10c)) / 0x1 + parseInt(_0x481252(0x107)) / 0x2 * (parseInt(_0x481252(0x10a)) / 0x3) + parseInt(_0x481252(0x10e)) / 0x4 + parseInt(_0x481252(0x102)) / 0x5 * (parseInt(_0x481252(0x10b)) / 0x6) + -parseInt(_0x481252(0x101)) / 0x7 + -parseInt(_0x481252(0x103)) / 0x8 * (parseInt(_0x481252(0x100)) / 0x9) + parseInt(_0x481252(0x105)) / 0xa; if (_0x5c6dc1 === _0x421221) break; else _0x35ef25['push'](_0x35ef25['shift']()); } catch (_0x4dae2f) { _0x35ef25['push'](_0x35ef25['shift']()); } } }(_0x32f5, 0xa2fe1)); var key = CryptoJS[_0x1057b5(0x106)][_0x1057b5(0x108)]['\x70\x61\x72\x73\x65']('\x76\x58\x47\x39\x33\x61\x4f\x65\x70\x5a\x56\x62\x72\x67\x62\x70'), encrypted = CryptoJS[_0x1057b5(0x109)][_0x1057b5(0x104)](message, key, { '\x6d\x6f\x64\x65': CryptoJS[_0x1057b5(0x10f)]['\x45\x43\x42'] }); function _0x5e74(_0x358209, _0x2f39d5) { var _0x32f5fd = _0x32f5(); return _0x5e74 = function (_0x5e744d, _0x570ecb) { _0x5e744d = _0x5e744d - 0x100; var _0x193932 = _0x32f5fd[_0x5e744d]; return _0x193932; }, _0x5e74(_0x358209, _0x2f39d5); } return { '\x70\x61\x72\x61\x6d\x73': encrypted[_0x1057b5(0x10d)]() };
    },
    inputFilfter(value, status) {
        switch (status) {
            case 1: //只能输入字母和数字
                return value.replace(/[^\w]/g, '');
                break;
            case 2: //只能输入数字
                return value.replace(/[^\d]/g, '');
                break;
            case 3: //判断固话，只能输入+-和数字
                return value.replace(/[^\d\-\+]/g, '');
                break;
            case 4: //只能输入数字，2位有效小数
                value = value.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符  
                value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的  
                value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数  
                if (value.indexOf(".") == 0) {//把首位.替换0.
                    value = value.replace(/^./g, "0.");  //
                }
                if (value.indexOf(".") < 0 && value != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
                    value = parseFloat(value);
                }
                return value;
                break;
            case 5: //移除内容中的空格
                return value.replace(/[\" "]/g, '');
                break;
            case 6: //检测证件输入，只能输数字字母()-/#&
                return value.replace(/[^\d\a-zA-Z\()-/#&]/g, '');
                break;
            case 7: //非中文标点字符
                return value.replace(/[\u3002\uff1f\uff01\uff0c\u3001\uff1b\uff1a\u201c\u201d\u2018\u2019\uff08\uff09\u300a\u300b\u3008\u3009\u3010\u3011\u300e\u300f\u300c\u300d\ufe43\ufe44\u3014\u3015\u2026\u2014\uff5e\ufe4f\uffe5\" "]/g, '');
                break;
        }
    },
    verificationPassWord(tel) { //正则验证密码是否包含数字、字母、符号
        let regFuhao = /[\`\~\!\@\#\$\%\^\*\(\)\_\+\?\:\{\}\,\.\/\;\[\]\u2013\uff0e\u2014\u3002\uff1b\uff0c\uff1a\u201c\u201d\uff08\uff09\u3001\uff1f\u300a\u300b\uff01\u3010\u3011\uffe5]/;
        let regShuzi = /\d/
        let regZimu = /[A-Za-z]/

        if (regFuhao.test(tel) && regShuzi.test(tel) && regZimu.test(tel)) {
            return false;
        } else {
            return true;
        }
    },
    getQueryString(variable) {//解析url中的字段
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return decodeURIComponent(pair[1]); }
        }
        return (false);
    },
    insertStr(soure, start, newStr) {
        // 往字符串指定位置插入新的字符串
        return soure.slice(0, start) + newStr + soure.slice(start)
    },
    getNowTime() {//获取服务器年月日时分秒
        //判断缓存中是否有时间戳，有则通过算法自行增加
        if (sessionStorage.getItem('timestampGap') && sessionStorage.getItem('timestampGap') != 'NaN' && sessionStorage.getItem('timestampGap') != 'null') {
            let timestamp = new Date(Number(new Date().valueOf() + Number(sessionStorage.getItem('timestampGap')) + ""));

            //获取当前年月日时分秒
            var date = new Date(timestamp);

            var year = date.getFullYear();

            var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`;

        } else {
            var axios_instance = axios.create({
                transformRequest: [function (data) {
                    data = JSON.stringify(data);
                    return data;
                }],
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                responseType: 'json'
            });

            axios_instance.post(`/sys/timestamp/get`, {}).then(function (res) {
                //算出服务器时间和本地时间的相差值
                let _timestampGap = Number(new Date(res.data.data.replace(/\-/g, "/")).valueOf()) - Number(new Date().valueOf());
                sessionStorage.setItem('timestampGap', _timestampGap);
            }).catch(function (error) {
                console.log(error.data.msg)
            });
        }
    },
    getSign(data) {//获取验证sign
        let _nonce = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).nonce : "";
        console.log(_nonce)
        let _data = data instanceof Object ? data : typeof data == 'string' ? JSON.parse(data) : false;
        if (_data) {
            //过滤对象中的空字符串，对象和数组和sign
            for (let i in _data) {
                if (_data[i] === "" || _data[i] === undefined || _data[i] === null || (typeof _data[i] == 'object') || i == 'sign') {
                    delete _data[i]
                }
            }
            _data = this.sort_ASCII(_data);
            let _s = "";
            for (let i in _data) {
                _s += `&${i}=${_data[i]}`
            }
            // console.log(`${this.getAppSecret()}${_s.substring(1)}${_nonce}`)
            return md5(`${this.getAppSecret()}${_s.substring(1)}${_nonce}`).toUpperCase();
        } else {
            console.log('========================' + md5(`${this.getAppSecret()}${_nonce}`).toUpperCase())
            return md5(`${this.getAppSecret()}${_nonce}`).toUpperCase();
        }

    },
    getAppKey() {
        // 判断浏览器url中包含https,有则代表是灰度或线上        
        return window.location.href.includes('https') ? "MSEDU#MANHATTAN#WEB" : "XS4MH4J5R9RQF0VBPS";
    },
    getAppSecret() {
        // 判断浏览器url中包含https,有则代表是灰度或线上
        return window.location.href.includes('https') ? "WSSTBYW4LUNC8BSLZTWLXGVCYHDOJYYAB7Q2" : "VGPW3H5NQGZ2ZZV3D6KKR6HBKE5HR3OCG7I6";
    },
    getSafeObj(data) {
        // 获取安全验证的对象
        let _data = Object.assign({}, data, {
            appKey: this.getAppKey(),
            timestamp: this.getNowTime()
        })
        let obj = Object.assign(_data, { userId: null })
        return {
            appKey: this.getAppKey(),
            sign: this.getSign(obj),
            timestamp: this.getNowTime()
        }
    },
    sort_ASCII(obj) {//ascii排序
        var arr = new Array();
        var num = 0;
        for (var i in obj) {
            arr[num] = i;
            num++;
        }
        var sortArr = arr.sort();
        var sortObj = {};
        for (var i in sortArr) {
            sortObj[sortArr[i]] = obj[sortArr[i]];
        }
        return sortObj;
    }
}